export const USER_BUYING_TYPES = {
	GIFT_VOUCHER: 'gift_voucher',
	CLICK_AND_COLLECT: 'clickAndCollect',
	CLICK_AND_SHOP: 'clickAndShop'
};
